import React from "react";
import { usd, periodLabel } from "./coffeeUi";
export default function CoffeeHistory({
  resource,
  page,
  setPage,
  onDetail,
  onRetry,
}) {
  const { data, loading, error } = resource;
  if (loading) return <p role="status">Cargando registros…</p>;
  if (error)
    return (
      <p role="alert">
        {error}{" "}
        <button type="button" onClick={onRetry}>
          Reintentar
        </button>
      </p>
    );
  if (!data?.items?.length) return <p>No hay registros para esta selección.</p>;
  return (
    <>
      <div className="coffee-table-wrap">
        <table className="coffee-table">
          <thead>
            <tr>
              <th>Período</th>
              <th>Ruta / máquina</th>
              <th>Operador</th>
              <th>Contadores</th>
              <th>Consumo</th>
              <th>Ventas USD</th>
              <th>Detalle</th>
            </tr>
          </thead>
          <tbody>
            {data.items.map((item) => (
              <tr key={item._id}>
                <td>
                  {periodLabel(item)}
                  <small>
                    {new Date(item.createdAt).toLocaleString("es-PA", {
                      timeZone: "America/Panama",
                    })}
                    {item.kind === "reset" ? " · Reinicio" : ""}
                  </small>
                </td>
                <td>
                  {item.snapshot?.route}
                  <small>
                    {item.snapshot?.name} · {item.snapshot?.serialNumber}
                  </small>
                </td>
                <td>{item.snapshot?.operator}</td>
                <td>
                  {item.previousCounter ?? "—"} → {item.currentCounter}
                </td>
                <td>{item.consumption ?? "—"}</td>
                <td>{usd(item.totalSalesCents)}</td>
                <td>
                  <button type="button" onClick={() => onDetail(item._id)}>
                    Ver detalle
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="coffee-pagination">
        <button
          type="button"
          disabled={page <= 1}
          onClick={() => setPage(page - 1)}
        >
          Anterior
        </button>
        <span>
          Página {page} · {data.total} registros
        </span>
        <button
          type="button"
          disabled={page * data.limit >= data.total}
          onClick={() => setPage(page + 1)}
        >
          Siguiente
        </button>
      </div>
    </>
  );
}
